// NGRX
import { createFeatureSelector, createSelector } from '@ngrx/store';
// Lodash
import { each } from 'lodash';
// CRUD
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
// State
import { WeightMeterState } from '../_reducers/weight-meter.reducers';
import { WeightMeter } from '../_models/weight-meter.model';

export const selectWeightMetersState = createFeatureSelector<WeightMeterState>('weightMeters');

export const selectWeightMeterById = (weightMeterId: number) => createSelector(
    selectWeightMetersState,
    weightMetersState => weightMetersState.entities[weightMeterId]
);

export const selectWeightMetersPageLoading = createSelector(
    selectWeightMetersState,
    weightMetersState => weightMetersState.listLoading
);

// export const selectWeightMetersActionLoading = createSelector(
//     selectWeightMetersState,
//     customersState => customersState.actionsloading
// );

export const selectWeightMetersPageLastQuery = createSelector(
    selectWeightMetersState,
    weightMetersState => weightMetersState.lastQuery
);

export const selectLastCreatedWeightMeterId = createSelector(
    selectWeightMetersState,
    weightMetersState => weightMetersState.lastCreatedWeightMeterId
);

export const selectLastUpdatedWeightMeterId = createSelector(
    selectWeightMetersState,
    weightMetersState => weightMetersState.lastUpdatedWeightMeterId
);

export const selectLastDeletedWeightMeterId = createSelector(
    selectWeightMetersState,
    weightMetersState => weightMetersState.lastDeletedWeightMeterId
);

export const selectWeightMetersInitWaitingMessage = createSelector(
    selectWeightMetersState,
    weightMetersState => weightMetersState.showInitWaitingMessage
);

export const selectWeightMetersInStore = createSelector(
    selectWeightMetersState,
    weightMetersState => {
        const items: WeightMeter[] = [];
        each(weightMetersState.entities, element => {
            items.push(element);
        });
        const httpExtension = new HttpExtenstionsModel();
        const result: WeightMeter[] = httpExtension.sortArray(items, weightMetersState.lastQuery.sortField, weightMetersState.lastQuery.sortOrder);
        return new QueryResultsModel(result, weightMetersState.totalCount, '');
    }
);

export const selectHasWeightMetersInStore = createSelector(
    selectWeightMetersInStore,
    queryResult => {
        if (!queryResult.totalCount) {
            return false;
        }

        return true;
    }
);